import { INewbuildingOfferDecorationInfoSchema } from '../../repositories/offer-card/entities/newbuilding_offer_decoration/NewbuildingOfferDecorationInfoSchema';
import { IState } from '../../store';

export const getDecorationInfo = (state: IState): INewbuildingOfferDecorationInfoSchema | undefined | null =>
  state.offerData.decorationInfo;
